<template>
    <div class="login" :style="{height:`${contentHeight}rem`}">
        <turnBack :content='content' :url='url' style="color:#FFF" />
        <div style="display: flex;flex-direction: column;align-items: center;margin-top:2rem">
            <img src="@/assets/img/news/APP ICON.png" alt="logo" style="width:5rem;margin:0px 10px">
            <span style="font-size:2rem">Welcome</span>
        </div>
        <div >
            <el-form class="loginForm" ref="form" :model="loginForm" style="margin:2rem 3rem">
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_user.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.phone" placeholder="输入手机号码"></el-input>
                </el-form-item>
                 <el-form-item >
                    <img src="@/assets/img/login/icon_login_pwd.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.password" placeholder="输入密码" show-password></el-input>
                </el-form-item>
                <el-button type="primary" @click="onLogin" style="background:#00999d;width:100%;border:1px solid #00999d">登录</el-button>
            </el-form>
            <div style="text-align:center">
                <span style="color:#8e96a6" @click="GotoPath('/login/forget')">忘记密码</span> 
                <span style="color:#8e96a6;margin:0rem 1rem" >|</span> 
                <span style="color:#8e96a6" @click="GotoPath('/login/register')">免费注册</span>
            </div>
        </div>
        <div  style="display: flex;flex-direction: column;align-items: center;margin-top:2rem">
            <span>---------其他登录方式-------------</span>
            <img src="@/assets/img/login/icon_login_wx.png" style="width:2rem;margin:10px 0px"/>
        </div>
    </div>
</template>
<script>
import turnBack from '@/components/turnBack'
import * as request from '@/utils/request'

export default {
    components:{
        turnBack,
    },
    data(){
        return {
            contentHeight:0,
            content:'登录',
            url:'/',
            loginForm:{
                password: "",
                phone: "",
            }
        }
    },
    mounted(){
        this.contentHeight = document.documentElement.clientHeight/16
    },
    methods:{
        onLogin(){
            request.login(this.loginForm).then( ({data}) =>{
                window.localStorage.setItem('x-token',data.token)
                this.getUserInfo(data.token)
            })
        },
        getUserInfo(token){
            request.getUsersInfoByToken({'x-token':token}).then( ({data})=>{
                window.localStorage.setItem('user',JSON.stringify(data))
                this.GotoPath('/')
                this.$message('登录成功')
            })
        },
        GotoPath(url){
            this.$router.push({ path: url })
        }
    }
}
</script>
<style lang="less" >
.login{
    background: url("~@/assets/img/login/icon_login_bg.png") 0 0 / cover;
    width: 100%;
    height: 100%;
    color: #FFF;
    .loginForm{
        .el-form-item{
            border-bottom: 1px solid #FFF;
        }
        .el-form-item__content{
            display: flex;
            align-items: center;
        }
        .el-input__inner{
            background: transparent;
            border: 0px;
        }
    }
}
</style>